import React from 'react'
import {Redirect, useRouteMatch} from 'react-router-dom'

import MenopauseAssessment from '@progyny/pages/Consultations/Menopause/MenopauseAssessment'
import PostpartumAssessment from '@progyny/pages/Consultations/P3/PostpartumAssessment'
import PregnancyAssessment from '@progyny/pages/Consultations/P3/PregnancyAssessment'
import ProgramViewContent, {
  ActiveTab,
} from '@progyny/pages/Consultations/Program/components/ProgramViewContent'
import ConsultationPageLayout from '@progyny/pages/Consultations/components/ConsultationPageLayout'
import ConsultationRoutes from '@progyny/pages/Consultations/components/ConsultationRoutes'

type ConsultationSlug = 'pregnancy' | 'postpartum' | 'menopause'

const useConsultationSlug = (): ConsultationSlug | undefined => {
  const {url} = useRouteMatch()

  if (url.endsWith('/pregnancy')) return 'pregnancy'
  if (url.endsWith('/postpartum')) return 'postpartum'
  if (url.endsWith('/menopause')) return 'menopause'
}

const FertilityRedirect = () => <Redirect to='/consultations/fertility' />

const ViewWrapper: React.FC<{
  activeTab: ActiveTab
  consultationSlug: ConsultationSlug
}> = ({activeTab, consultationSlug}) => {
  return (
    <ConsultationPageLayout consultationSlug={consultationSlug}>
      {(
        consultation,
        colors,
        theme,
        refetchConsultationDetail,
        _onCalendarVisibilityChange,
        onTabsVisibilityChange
      ) => (
        <ProgramViewContent
          consultation={consultation}
          colors={colors}
          theme={theme}
          activeTab={activeTab}
          onRefetchConsultationDetail={refetchConsultationDetail}
          consultationSlug={consultationSlug}
          onTabsVisibilityChange={onTabsVisibilityChange}
        />
      )}
    </ConsultationPageLayout>
  )
}

const ConsultationPage: React.FC = () => {
  const consultationSlug = useConsultationSlug()

  if (!consultationSlug) {
    return <FertilityRedirect />
  }

  return (
    <ConsultationRoutes
      consultationSlug={consultationSlug}
      assessmentComponent={
        consultationSlug === 'pregnancy'
          ? PregnancyAssessment
          : consultationSlug === 'postpartum'
            ? PostpartumAssessment
            : MenopauseAssessment
      }
      overviewComponent={() => (
        <ViewWrapper activeTab='overview' consultationSlug={consultationSlug} />
      )}
      onboardingSlugOverride={
        consultationSlug === 'menopause'
          ? undefined
          : `${consultationSlug}-support`
      }
      upcomingPastView={({activeTab}) => (
        <ViewWrapper
          activeTab={activeTab}
          consultationSlug={consultationSlug}
        />
      )}
    />
  )
}

export default ConsultationPage
